import { upsellElements } from './upsellElements';

export const closeCart = (cartObserver: MutationObserver) => {
  const { cartModal, cartWrapper } = upsellElements();
  const cartStyleAttribute = cartModal.getAttributeNode('style');
  const wrapperAttribute = cartWrapper.getAttributeNode('data-cart-open');

  if (cartStyleAttribute && wrapperAttribute) {
    cartWrapper.removeAttributeNode(wrapperAttribute);
    cartModal.removeAttributeNode(cartStyleAttribute);
    cartModal.style.display = 'none';
    cartModal.style.opacity = '1';
    cartObserver.disconnect();
  }
};
